exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stars svg[data-v-67f306fe] {\n  left: -80px;\n  -webkit-animation: slide-right-data-v-67f306fe 5s linear infinite;\n          animation: slide-right-data-v-67f306fe 5s linear infinite;\n}\n@-webkit-keyframes slide-right-data-v-67f306fe {\n0% {\n    transform: translateX(0);\n}\n100% {\n    transform: translateX(calc(100vw + 80px));\n}\n}\n@keyframes slide-right-data-v-67f306fe {\n0% {\n    transform: translateX(0);\n}\n100% {\n    transform: translateX(calc(100vw + 80px));\n}\n}", ""]);

// exports
